import React, { Component } from "react";
import TemplateCard from "./templateCard";

class TemplateCardTable extends Component {

  render() {
    const { data, notifyUpdate } = this.props;

    return (
      <div className="row">
        {data && data.map( item => {
          return (
            <div key={item._id} className="col-auto">
              <TemplateCard item={item} notifyUpdate={notifyUpdate} />
            </div>
          )
        })}
      </div>
    );
  }
}

export default TemplateCardTable;
